// extracted by mini-css-extract-plugin
module.exports = {"products":"pi-z","misad":"qi-z","oosMessaging":"ri-z","topProductFrame":"si-z","productCardOverrides":"ti-z","secondRowAds":"ui-z","microsoftAdsWrapper":"vi-z"};